import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { map as __map, filter as __filter } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../api-configuration";
import * as i2 from "@angular/common/http";
/**
 * Web Page Rest Controller
 */
class WebPageRestControllerService extends __BaseService {
    constructor(config, http) {
        super(config, http);
    }
    /**
     * @param params The `WebPageRestControllerService.FindOneUsingGET2Params` containing the following parameters:
     *
     * - `filePath`: filePath
     *
     * - `collectionTypeName`: collectionTypeName
     *
     * - `revisionTag`: revisionTag
     *
     * @return OK
     */
    findOneUsingGET2Response(params) {
        let __params = this.newParams();
        let __headers = new HttpHeaders();
        let __body = null;
        if (params.filePath != null)
            __params = __params.set('filePath', params.filePath.toString());
        if (params.revisionTag != null)
            __params = __params.set('revisionTag', params.revisionTag.toString());
        let req = new HttpRequest('GET', this.rootUrl + `/api/webitem/collection/${params.collectionTypeName}/items/webpage`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(__filter(_r => _r instanceof HttpResponse), __map((_r) => {
            return _r;
        }));
    }
    /**
     * @param params The `WebPageRestControllerService.FindOneUsingGET2Params` containing the following parameters:
     *
     * - `filePath`: filePath
     *
     * - `collectionTypeName`: collectionTypeName
     *
     * - `revisionTag`: revisionTag
     *
     * @return OK
     */
    findOneUsingGET2(params) {
        return this.findOneUsingGET2Response(params).pipe(__map(_r => _r.body));
    }
    /**
     * @param params The `WebPageRestControllerService.SaveUsingPOST1Params` containing the following parameters:
     *
     * - `item`: item
     *
     * - `filePath`: filePath
     *
     * - `collectionTypeName`: collectionTypeName
     *
     * - `revisionTag`: revisionTag
     *
     * @return OK
     */
    saveUsingPOST1Response(params) {
        let __params = this.newParams();
        let __headers = new HttpHeaders();
        let __body = null;
        __body = params.item;
        if (params.filePath != null)
            __params = __params.set('filePath', params.filePath.toString());
        if (params.revisionTag != null)
            __params = __params.set('revisionTag', params.revisionTag.toString());
        let req = new HttpRequest('POST', this.rootUrl + `/api/webitem/collection/${params.collectionTypeName}/items/webpage`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(__filter(_r => _r instanceof HttpResponse), __map((_r) => {
            return _r;
        }));
    }
    /**
     * @param params The `WebPageRestControllerService.SaveUsingPOST1Params` containing the following parameters:
     *
     * - `item`: item
     *
     * - `filePath`: filePath
     *
     * - `collectionTypeName`: collectionTypeName
     *
     * - `revisionTag`: revisionTag
     *
     * @return OK
     */
    saveUsingPOST1(params) {
        return this.saveUsingPOST1Response(params).pipe(__map(_r => _r.body));
    }
    /**
     * @param params The `WebPageRestControllerService.GetResourcesUsingGET1Params` containing the following parameters:
     *
     * - `collectionTypeName`: collectionTypeName
     *
     * - `revisionTag`: revisionTag
     *
     * @return OK
     */
    getResourcesUsingGET1Response(params) {
        let __params = this.newParams();
        let __headers = new HttpHeaders();
        let __body = null;
        if (params.revisionTag != null)
            __params = __params.set('revisionTag', params.revisionTag.toString());
        let req = new HttpRequest('GET', this.rootUrl + `/api/webitem/collection/${params.collectionTypeName}/items/webpage/all`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(__filter(_r => _r instanceof HttpResponse), __map((_r) => {
            return _r;
        }));
    }
    /**
     * @param params The `WebPageRestControllerService.GetResourcesUsingGET1Params` containing the following parameters:
     *
     * - `collectionTypeName`: collectionTypeName
     *
     * - `revisionTag`: revisionTag
     *
     * @return OK
     */
    getResourcesUsingGET1(params) {
        return this.getResourcesUsingGET1Response(params).pipe(__map(_r => _r.body));
    }
    /**
     * @param params The `WebPageRestControllerService.SavePreferencesUsingPOST1Params` containing the following parameters:
     *
     * - `item`: item
     *
     * - `filePath`: filePath
     *
     * - `collectionTypeName`: collectionTypeName
     *
     * - `revisionTag`: revisionTag
     *
     * @return OK
     */
    savePreferencesUsingPOST1Response(params) {
        let __params = this.newParams();
        let __headers = new HttpHeaders();
        let __body = null;
        __body = params.item;
        if (params.filePath != null)
            __params = __params.set('filePath', params.filePath.toString());
        if (params.revisionTag != null)
            __params = __params.set('revisionTag', params.revisionTag.toString());
        let req = new HttpRequest('POST', this.rootUrl + `/api/webitem/collection/${params.collectionTypeName}/items/webpage/preferences`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(__filter(_r => _r instanceof HttpResponse), __map((_r) => {
            return _r;
        }));
    }
    /**
     * @param params The `WebPageRestControllerService.SavePreferencesUsingPOST1Params` containing the following parameters:
     *
     * - `item`: item
     *
     * - `filePath`: filePath
     *
     * - `collectionTypeName`: collectionTypeName
     *
     * - `revisionTag`: revisionTag
     *
     * @return OK
     */
    savePreferencesUsingPOST1(params) {
        return this.savePreferencesUsingPOST1Response(params).pipe(__map(_r => _r.body));
    }
}
WebPageRestControllerService.ngInjectableDef = i0.defineInjectable({ factory: function WebPageRestControllerService_Factory() { return new WebPageRestControllerService(i0.inject(i1.ApiConfiguration), i0.inject(i2.HttpClient)); }, token: WebPageRestControllerService, providedIn: "root" });
export { WebPageRestControllerService };
